export const environment = {
    production: false,
    baseUrl: 'https://api.preview.ebem.be',
    umbracoUrl: 'https://umbraco.preview.ebem.be',
    siteKey: '0x4AAAAAABAlfFI37CDonC8Z'
};